import React, { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";

export const ChangePassword = () => {
  const { t } = useLang();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 6) { toast.error(t("password_min")); return; }
    if (next !== confirm) { toast.error(t("passwords_mismatch")); return; }
    setLoading(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      setCurrent(""); setNext(""); setConfirm("");
      toast.success(t("password_changed"));
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="change-password" className="space-y-4">
      <h2 className="font-heading font-bold text-xl flex items-center gap-2">
        <KeyRound className="w-5 h-5 text-signal" /> {t("change_pw_title")}
      </h2>
      <div className="border border-white/10 bg-panel p-6">
        <p className="font-mono text-[11px] text-white/40 mb-4">{t("change_pw_desc")}</p>
        <form onSubmit={submit} className="grid gap-4 max-w-sm">
          <div>
            <Label className="text-white/70 text-xs uppercase tracking-wider">{t("current_password")}</Label>
            <Input
              data-testid="cp-current" type="password" value={current} onChange={(e) => setCurrent(e.target.value)} required
              className="mt-1.5 bg-base border-white/10 text-white focus-visible:ring-signal rounded-sm"
            />
          </div>
          <div>
            <Label className="text-white/70 text-xs uppercase tracking-wider">{t("new_password")}</Label>
            <Input
              data-testid="cp-new" type="password" value={next} onChange={(e) => setNext(e.target.value)} required
              className="mt-1.5 bg-base border-white/10 text-white focus-visible:ring-signal rounded-sm"
            />
          </div>
          <div>
            <Label className="text-white/70 text-xs uppercase tracking-wider">{t("confirm_password")}</Label>
            <Input
              data-testid="cp-confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required
              className="mt-1.5 bg-base border-white/10 text-white focus-visible:ring-signal rounded-sm"
            />
          </div>
          <Button
            data-testid="cp-submit" type="submit" disabled={loading}
            className="bg-signal text-black hover:bg-white rounded-sm font-semibold w-fit"
          >
            {loading ? "…" : t("save_password")}
          </Button>
        </form>
      </div>
    </div>
  );
};
